import PostingScheduleType from "@/models/Shared/PostingScheduleType";

export default (postingScheduleType: PostingScheduleType) => {
    let returnVal = "Undefined";
    switch (postingScheduleType) {
        case PostingScheduleType.FixedSchedule:
            returnVal = "Fixed Schedule"
            break;
        case PostingScheduleType.AnniversaryAccountOpen:
            returnVal = "Anniversary Account Open"
            break;
        case PostingScheduleType.AnniversaryFirstTransaction:
            returnVal = "Anniversary First Transaction"
            break;
    }
    return returnVal;
}